import ticinoLogo from '../static/images/temporary_logo.png';
import smartphoneApp from '../static/images/smartphone_app.png';
import { BrownButton } from './buttons';
import { useTranslation } from 'react-i18next';

function DownloadAppSection() {
    const {t} = useTranslation();   
    return (
        <div className='mt-8 w-full lg:w-[1200px] flex flex-col-reverse md:flex-row items-center'>
            <div><img src={smartphoneApp} alt="Smartphone App" /></div>
            <div className='text-[#225424] text-center'>
                <h1 className='hidden md:block'>{t("Homepage.DownloadAppSection.add")}</h1>
                <h2 className='md:hidden'>{t("Homepage.DownloadAppSection.add")}</h2>
                <img src={ticinoLogo} alt="Ticino Logo" />
                <h1 className='hidden md:block'>{t("Homepage.DownloadAppSection.toHome")}</h1>
                <h2 className='md:hidden'>{t("Homepage.DownloadAppSection.toHome")}</h2>
                <h1 className='hidden md:block'>{t("Homepage.DownloadAppSection.ofYourDevice")}</h1>
                <h2 className='md:hidden'>{t("Homepage.DownloadAppSection.ofYourDevice")}</h2>
                <div className='my-4'>
                    <BrownButton text={t("Homepage.DownloadAppSection.discoverMore")} link="/download-app-tutorial" />
                </div>

            </div>
        </div>
    )
}

export default DownloadAppSection